import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useError, useForm } from '../../hooks'

import TextField from '../Form/TextField'
import DropdownField from '../Form/DropdownField'
import Button from '../Button'
import Spinner from '../Spinner'
import { useFirebaseCRUD } from '../../hooks/useFirebaseCRUD'
import { arrayUnion, doc, getDoc, updateDoc } from 'firebase/firestore'
import { db } from '../../firebase'

export default function ({ siteId }) {
  const navigate = useNavigate()
  const { getDocument, getCollection, createDocument } = useFirebaseCRUD()
  const setError = useError()

  const [site, setSite] = useState(null)
  const [organizations, setOrganizations] = useState([])
  const [loading, setLoading] = useState(true)

  const [getFieldProps, formData, formError] = useForm()

  // Load site and organizations
  useEffect(() => {
    async function fetchData() {
      setLoading(true)
      try {
        const siteData = await getDocument(`sites/${siteId}`)
        // Unfiltered on purpose, same as CreateDispatchBinding: a site is bound
        // to an arbitrary organisation, so `allow list: if member()` in
        // firestore.rules is what makes this dropdown possible at all.
        let orgs = await getCollection('organizations')
        
        // Sort organizations by name ascending
        orgs = orgs.sort((a, b) => a.name.localeCompare(b.name))
        
        setSite(siteData)
        setOrganizations(orgs)
      } catch (err) {
        setError(err)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [siteId])

  if (loading || !site) {
    return <Spinner />
  }

  async function handleSubmit(e) {
    e.preventDefault()

    const { organizationId } = formData

    try {
      // Create organization binding in Firebase
      const orgDoc = await getDoc(doc(db, 'organizations', organizationId))


      // replce thing 
      // await createDocument(
      //   `sites/${siteId}/organization-bindings/${organizationId}`,
      //   {
      //     organizationId,
      //     organization: {
      //       id: organizationId,
      //       name: orgDoc.data().name,
      //     },
      //     createdAt: new Date().toISOString(),
      //   }
      // )


      // alternative thing
      const siteRef = doc(db, 'sites', siteId)

      await updateDoc(siteRef, {
        organization_bindings: arrayUnion(organizationId)
      })

      navigate(`/sites/${siteId}`)
    } catch (err) {
      if (err.message === 'validation_error') {
        formError(err.props)
      } else {
        setError(err)
      }
    }
  }

  return (
    <div className='box'>
      <form onSubmit={handleSubmit}>
        <TextField label='Site' value={site.name} readOnly={true} />
        <DropdownField
          name='organizationId'
          label='Organization'
          required={true}
          {...getFieldProps()}>
          <option />

          {organizations.map(({ id, name }) => (
            <option value={id} key={id}>
              {name}
            </option>
          ))}
        </DropdownField>
        <div className='level'>
          <div className='level-left' />
          <div className='level-right'>
            <div className='level-item'>
              <Button type='submit'>Submit</Button>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}